// extracted by mini-css-extract-plugin
export default {"container":"Dots_container__T1+S+"};